import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import type { WorkspaceViewProps } from './types';
import { WorkspaceViewSkeleton } from './WorkspaceViewSkeleton';

/**
 * Registry mapping tenant codes to lazy-loaded workspace view components.
 *
 * To add a new tenant view:
 * 1. Create a new component in this directory (e.g. ZebraWorkspaceView.tsx)
 * 2. Add an entry below: 'ZEBRA': dynamic(() => import('./ZebraWorkspaceView'), ...)
 * 3. Set workspace.use_custom_view = true for the tenant in sm_core_sysconfigurations
 */
const viewRegistry: Record<string, ComponentType<WorkspaceViewProps>> = {
  TLT: dynamic(() => import('./TltWorkspaceView'), {
    loading: () => WorkspaceViewSkeleton(),
  }),
};

/**
 * Resolves a workspace view component for the given tenant.
 * Returns the custom component if enabled and registered, or null to indicate
 * the caller should use DefaultWorkspaceView.
 */
export function resolveWorkspaceView(
  tenantCode: string,
  useCustomWorkspace: boolean
): ComponentType<WorkspaceViewProps> | null {
  if (!useCustomWorkspace) return null;
  return viewRegistry[tenantCode] ?? null;
}
